import { render } from "./SoftSelect.vue?vue&type=template&id=2cabef04&scoped=true"
import script from "./SoftSelect.vue?vue&type=script&lang=js"
export * from "./SoftSelect.vue?vue&type=script&lang=js"

import "./SoftSelect.vue?vue&type=style&index=0&id=2cabef04&scoped=true&lang=css"

import exportComponent from "C:\\xampp-80\\htdocs\\v2crmred\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cabef04"]])

export default __exports__